<template>
    <div>
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">{{ $t('subscriptionsPage.manageSubscriptions') }}</h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <card>
                        <el-tabs
                            v-model="selectedHotelIdSubscriptionsTab"
                            :class="{'hide-tab-pane': hotels.length === 1}">
                            <el-tab-pane
                                v-for="hotel in hotels"
                                :key="hotel.id"
                                :label="hotel.name"
                                :name="hotel.id.toString()">
                                <el-table
                                    class="table-responsive table-flush"
                                    header-row-class-name="thead-light"
                                    :data="filteredSubscriptions"
                                    :empty-text="isLoadingData
                                    ? $t('general.loading') + '...'
                                    : $t('subscriptionsPage.noAppAddedToHotelGroup')"
                                    :row-class-name="({row}) => row._statusColor ? 'row-' + row._statusColor : ''"
                                    lazy>

                                    <el-table-column type="expand" width="50px" v-slot="{row: app}">
                                        <div v-if="app.subscription && !isNaN(app.subscription.id)">
                                            <p><b>{{ $t('general.hotel') }}:</b> {{ app.hotel.name }}</p>
                                            <p><b>{{ $tc('general.application', 1) }}:</b> {{ app.name }}</p>
                                            <p><b>{{ $t('subscriptionsPage.subscriptionStartedAt') }}:</b>
                                                {{ app.subscription.start_at }}
                                            </p>
                                            <p>
                                                <b>{{ $t('subscriptionsPage.subscriptionExpirationDate') }}:</b>
                                                {{ app.subscription.expiry_at }}
                                                <span :class="'text-' + app._statusColor">
                                                    <b>{{ app.subscription.status }}</b>
                                                </span>
                                            </p>
                                            <p>
                                                <b>{{ $t('subscriptionsPage.contractExpirationDate') }}:</b>
                                                {{ app.subscription.contract_expiry_at }}
                                                <span :class="'text-' + app._contractStatusColor">
                                                    <b>{{ app.subscription.contractStaus }}</b>
                                                </span>
                                            </p>
                                            <p><b>{{ $t('subscriptionsPage.subscriptionPrice') }}:</b>
                                                {{ app.subscription.price }}
                                                {{ app.subscription.currency }}/month</p>
                                            <p>
                                                <b>{{ $t('subscriptionsPage.billingFrequency') }}:</b>
                                                {{ $tc('subscriptionsPage.billingFrequencyMessage',
                                                app.subscription.billing_frequency) }}
                                            </p>
                                            <p>
                                                <b>{{ $t('subscriptionsPage.contactPerson') }}:</b>
                                                {{ app.subscription.contact.name }}
                                                <{{ app.subscription.contact.email }}>
                                                <span
                                                    v-if="app.subscription.contact && app.subscription.contact.deleted_at"
                                                    class="text-danger">
                                                    <b>{{ $t('subscriptionsPage.inactiveContactPersonMessage') }}</b>
                                                </span>
                                            </p>
                                        </div>
                                        <div v-else>
                                            <p>{{ $t('subscriptionsPage.noSubscriptionMessage') }} 😕</p>
                                        </div>
                                    </el-table-column>

                                    <el-table-column
                                        :label="$tc('general.application, 1')"
                                        prop="name"
                                        sortable/>

                                    <el-table-column
                                        :label="$t('general.expiryAt')"
                                        prop="subscription.expiry_at"
                                        sortable/>

                                    <el-table-column
                                        :label="$t('general.status')"
                                        prop="subscription.status"
                                        sortable/>

                                    <el-table-column
                                        :label="$t('general.timeLeft')"
                                        prop="subscription.timeLeft"
                                        sortable/>

                                    <!--
                                    <el-table-column
                                        :label="$t('general.actions')"
                                        width="160px"
                                        v-slot="{row: app}">
                                        <el-button
                                            size="mini"
                                            :type="app._statusColor"
                                            @click="viewSubscription(app.subscription)">Show details
                                        </el-button>
                                    </el-table-column>
                                    -->

                                </el-table>
                            </el-tab-pane>
                        </el-tabs>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';
    import {BaseProgress} from '@/components';
    import {
        Button,
        Dialog,
        Form,
        FormItem,
        Option,
        Select,
        Table,
        TableColumn,
        TabPane,
        Tabs,
        Tooltip,
    } from 'element-ui'

    export default {
        name: 'user-list',
        components: {
            BaseProgress,
            [Button.name]: Button,
            [Dialog.name]: Dialog,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Select.name]: Select,
            [Option.name]: Option,
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane,
            [Tooltip.name]: Tooltip,
        },
        computed: {
            filteredSubscriptions: {
                get() {
                    let data = JSON.parse(JSON.stringify(this.applications));

                    this.itemsCount = data.length;

                    data = data.map(app => {
                        const selectedHotel = this.hotels.find(hotel => hotel.id === +this.selectedHotelIdSubscriptionsTab);
                        app.subscription = selectedHotel
                            ? selectedHotel.subscriptions.find(subs => subs.application_id === app.id)
                            : null;

                        if (app.subscription) {
                            app.hotel = selectedHotel;
                            app.subscription.status = this.$moment().isBefore(app.subscription.start_at)
                                ? this.$t('general.notActiveYet')
                                : this.$moment().isBetween(app.subscription.start_at, app.subscription.expiry_at, null, '[]')
                                    ? this.$t('general.active')
                                    : this.$t('general.expired');

                            app._statusColor = app.subscription.status === this.$t('general.expired') ? 'danger' : '';
                            app.subscription.contractStaus = this.$moment().isAfter(app.subscription.contract_expiry_date) ? this.$t('general.expired') : '';
                            app._contractStatusColor = app.subscription.contractStaus === this.$t('general.expired') ? 'danger' : '';

                            if (['HUF'].includes(app.subscription.currency)) {
                                app.subscription.price = parseInt(app.subscription.price);
                            }

                            // const diff = this.$moment(app.subscription.expiry_at).diff();
                            //app.subscription.timeLeft = this.$moment.duration(diff, 'milliseconds').humanize() + ' left';
                            app.subscription.timeLeft = this.$moment(app.subscription.expiry_at).fromNow();
                        } else {
                            app.subscription = {};
                        }

                        return app;
                    });

                    return data;
                },
            },
        },
        data() {
            return {
                hotels: [],
                applications: [],
                currentPage: 1,
                itemsPerPage: 10,
                itemsCount: 0,
                isLoadingData: true,
                selectedHotelIdSubscriptionsTab: null,
            }
        },
        methods: {
            viewSubscription(subscription) {
                console.log('Subscription', subscription);
            },
        },
        async created() {
            this.isLoadingData = true;
            this.hotels = (await this.$axios.get('/api/hotels?include=subscriptions')).data.data;
            this.applications = (await this.$axios.get('/api/applications')).data.data;
            this.isLoadingData = false;

            this.selectedHotelIdSubscriptionsTab = this.hotels.length > 0 ? this.hotels[0].id.toString() : null;
        }
    }
</script>
<style lang="scss">
    .filter-container {
        display: inline-flex;
        margin-right: .5rem;
    }

    .permission-editor-modal {
        .el-dialog__body {
            padding: 0;
        }
    }

    .permission-pagination {
        display: table;
        margin-left: auto;
        margin-right: auto;
        margin-top: 1rem;
    }

    .flex-right {
        display: flex;
        justify-content: flex-end;
    }
</style>
